<template>
    <main>
        <header>
            <hgroup>
                <slot name="header">
                    <h1 v-text="title" />
                </slot>
            </hgroup>
            <slot name="nav"/>        
        </header>
        <slot />
    </main>
</template>

<script>
export default {
	props: {
		title: {
            type: String,
            default: 'No Title'
        }
	}
};
</script>